import React, { useState, useCallback, useEffect } from 'react'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { useRequisicaoService } from 'hooks/useRequisicaoService'
import { TextField, Checkbox, CircularProgress } from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const SelectRequisicao = (props) => {
  const requisicaoService = useRequisicaoService()
  const [requisicoes, setRequisicoes] = useState(null)
  const { requisicoesExternos, setRequisicoesExternos, setProcessando, label, multiplo } = props
  const [listaOpcoesRequisicoesFiltros, setListaOpcoesRequisicoesFiltros] = useState([])
  const [inputRequisicao, setInputRequisicao] = useState(null)

  const fetchRequisicoes = useCallback(async () => {
    // const response = await requisicaoService.listarRequisicoes(setProcessando)
    const response = await requisicaoService.listarRequisicoesPorSetores(setProcessando)
    setRequisicoes(response)
  }, [])

  useEffect(() => {
    fetchRequisicoes()
  }, [fetchRequisicoes])

  const handleChangeInputRequisicao = useCallback(
    (value) => {
      setInputRequisicao(value)
      if (requisicoes) {
        if (value?.length > 2) {
          setListaOpcoesRequisicoesFiltros((prevState) =>
            requisicoes.filter((requisicao) => {
              if (requisicao.identificador?.toUpperCase().includes(value?.toUpperCase())) {
                return requisicao
              }
            })
          )
        } else {
          setListaOpcoesRequisicoesFiltros([])
        }
      }
    },
    [requisicoes]
  )

  return (
    <AutocompleteNative
      value={requisicoesExternos}
      name="requisicao"
      noOptionsText="Sem informações"
      disabled={requisicoes === null || requisicoes.length === 0}
      loading={requisicoes === null}
      required
      multiple={multiplo}
      options={listaOpcoesRequisicoesFiltros || []}
      onChange={(event, newValue) => {
        setRequisicoesExternos(newValue)
      }}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => `REQUISIÇÃO ${option.identificador?.toUpperCase()} - RIP ${option.identificador_caso_rip}`}
      renderOption={(option, { selected }) => (
        <>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{
              marginRight: 8,
            }}
            checked={selected}
          />
          {`REQUISIÇÃO ${option.identificador?.toUpperCase()} - RIP ${option.identificador_caso_rip}`}
        </>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          InputLabelProps={{
            shrink: true,
          }}
          value={inputRequisicao}
          onChange={(e) => handleChangeInputRequisicao(e.target.value)}
          onPaste={(e) => {
            const pastedText = e.clipboardData.getData('text')
            setInputRequisicao(pastedText)
            handleChangeInputRequisicao(pastedText)
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {requisicoes === null && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          placeholder={requisicoes === null ? 'Carregando...' : ''}
        />
      )}
    />
  )
}
